import type {InstagramAudioTrack} from '@Components/social-media-wizard/social-media-wizard.types';

export const INSTAGRAM_AUDIO_SEARCH_CACHE_TTL_MS = 10 * 60 * 1000;

export interface InstagramAudioSearchCacheEntry {
  request: Promise<InstagramAudioTrack[]>;
  tracks: InstagramAudioTrack[] | null;
  cachedAt: number;
}
